import { useState } from "react"
import Select from "./Select"
import styles from "./FrequencySelector.module.css"
import TextInput from "./TextInput"
import typo from "../typography.module.css"

const FrequencySelector = ({ defaultOption = { n: 1, f: 'month' }, onChange, label }) => {

    const options = [
        { id: 0, name: 'Giorni', value: 'day' },
        { id: 1, name: 'Settimane', value: 'week' },
        { id: 2, name: 'Mesi', value: 'month' },
        { id: 3, name: 'Anni', value: 'year' },
    ]


    const [number, setNumber] = useState(defaultOption.n ?? 1);
    const [unit, setUnit] = useState(defaultOption.f ?? options[2].value);

    return (
        <div className={styles.unitSelector}>
            {label &&
                <div className={typo.caption}>{label}</div>
            }
            <div className={styles.container}>
                <TextInput type="number" numberType="int" decimals={3} placeholder={"0"} value={number} style={{ minWidth: '40px', fontSize: '0.875rem', border: 'none', padding: '.5rem', borderRight: '1px solid rgba(var(--text-color-rgb), 12%)', borderRadius: '1rem 0 0 1rem' }}
                    onKeyUp={(v, rawV) => {
                        setNumber(v)
                        onChange(v, unit)
                    }} />
                <Select options={options} selected={options.find(o => o.value === unit) ?? options[0]} placeholder="" style={{ border: 'none', padding: '.5rem', fontSize: '0.875rem' }} onSelect={(option) => {
                    setUnit(option.value);
                    onChange(number, option.value);
                }} />
            </div>
        </div>
    )
}

export default FrequencySelector